<!-- 收入记录 -->
<template>
  <div class="order">
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="商品 ID" prop="id" />
      <el-table-column label="商品名称" prop="name" />
      <el-table-column label="描述" prop="desc" />
    </el-table>
    <div>收入记录</div>
  </div>
</template>

<script>

export default {
  name:'IncomeLog',
  components: {},
  data() {
    return {
      tableData: [{
        id: '12987123',
        name: '好滋好味鸡蛋仔',
        category: '江浙小吃、小吃零食',
        desc: '荷兰优质淡奶，奶香浓而不腻',
        address: '上海市普陀区真北路',
        shop: '王小虎夫妻店',
        shopId: '10333'
      }]
    };
  },
  props:{
    mId: {
      type: String || Number,
      default:'',
    },
  },
  computed: {},
  watch: {},
  methods: {
    goLink(){
      let url = '/reportMerchant/reportMerchant-outApply'
      this.$router.push(url);
    }
  },
  created() {

  },
  mounted() {

  },
  beforeCreate() { },
  beforeMount() { },
  beforeUpdate() { },
  updated() { },
  beforeDestroy() { },
  destroyed() { },
  activated() { },
}
</script>
<style lang='scss' scoped>
</style>
